import { FaxTypes } from 'generated/graphql-types';
import { FaxTypeOption } from 'src/app/pages/fax-register/models/fax-type-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { faxTypeOptionActions } from './fax-type-option.actions';

export const faxTypeOptionFeatureKey = 'faxTypeOptions';

export type FaxTypeOptionState = EagerSelectState<FaxTypeOption>;

const adapter = createEagerSelectAdapter<FaxTypeOptionState, FaxTypeOption>({
   featureKey: faxTypeOptionFeatureKey,
   selectId: (fax: FaxTypeOption) => {
      return fax.typeName ? fax.typeName : '';
   },
});

export const faxTypeOptionSelectors = adapter.getSelectors(filterTypeNameOption);

const initialState = adapter.getInitialState();

export const faxTypeOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   faxTypeOptionActions.search,
   faxTypeOptionActions.searchReset,
   faxTypeOptionActions.loadFromApi,
   faxTypeOptionActions.loadFromApiSuccess,
   faxTypeOptionActions.loadFromApiFailure
);

export function filterTypeNameOption<T extends FaxTypeOption>(types: T[], searchText: string | null | undefined): T[] {
   const filteredOptions: T[] = Object.values(FaxTypes)
      .filter((typeName) => {
         if (searchText) {
            return typeName.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((typeName) => {
         return { typeName } as T;
      });

   return filteredOptions;
}
